export default "__VITE_ASSET__Cv67d6FA__"